import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

abstract class BaseFormData {
  public formGroup: FormGroup;

  abstract getFormGroup(): FormGroup;

  migrateFormData(): void {
    const fg = this.getFormGroup();
    const props = Object.getOwnPropertyNames(this);
    for (const prop of props) {
      this[prop] = fg.value[prop];
    }
  }

  isDataValid(): boolean {
    return this.getFormGroup().valid;
  }
}

export class FirmInformationPage extends BaseFormData {
  constructor() {
    super();
  }

  firstName: string = null;
  lastName: string = null;
  email: string = null;
  phone: string = null;
  title: string = null;

  marketingFile;
  trackRecordFile;

  firmName: string = null;
  streetAddress: string = null;
  city: string = null;
  country: string = null;
  yearOfInception: string = null;
  firmwideAssetsUnderManagement: string = null;
  firmwideEmployee: string = null;
  briefDescription: string = null;

  getFormGroup(): FormGroup {
    if (!this.formGroup) {
      this.formGroup = new FormGroup({
        firstName: new FormControl(
          this.firstName,
          Validators.required
        ),
        lastName: new FormControl(
          this.lastName,
          Validators.required
        ),
        email: new FormControl(
          this.email,
          [Validators.required, Validators.email]
        ),
        phone: new FormControl(
          this.phone,
          Validators.required
        ),
        title: new FormControl(
          this.title,
          Validators.required
        ),
        marketingFile: new FormControl(),
        trackRecordFile: new FormControl(),
        firmName: new FormControl(
          this.firmName,
          Validators.required
        ),
        streetAddress: new FormControl(
          this.streetAddress,
          Validators.required
        ),
        country: new FormControl(
          this.country,
          [Validators.required, Validators.nullValidator]
        ),
        city: new FormControl(
          this.city,
          Validators.required
        ),
        yearOfInception: new FormControl(
          this.yearOfInception,
          [Validators.required, Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')]
        ),
        firmwideAssetsUnderManagement: new FormControl(
          this.firmwideAssetsUnderManagement,
          [Validators.required, Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')]
        ),
        firmwideEmployee: new FormControl(
          this.firmwideEmployee,
          [Validators.required, Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')]
        ),
        briefDescription: new FormControl(
          this.briefDescription,
          Validators.required
        )
      });
    }

    return this.formGroup;
  }
}

export class InvestmentStrategyMainPage extends BaseFormData {

  fundName: string = null;
  fundType: string = null;
  partnership: string = null;
  preExistingContact: string = null;

  constructor() {
    super();
  }

  getFormGroup(): FormGroup {
    // console.log(this.formGroup);
    if (!this.formGroup) {
      this.formGroup = new FormGroup({
        fundName: new FormControl(this.fundName, [Validators.required]),
        fundType: new FormControl(this.fundType, [Validators.required, Validators.pattern('^((?!fundtype).)*$')]),
        partnership: new FormControl(this.partnership, [Validators.required, Validators.pattern('^((?!partnership).)*$')]),
        preExistingContact: new FormControl(this.preExistingContact, [Validators.required, Validators.pattern('^((?!preExistingContact).)*$')])
      });
    }
    return this.formGroup;
  }
}

export class OpenEndFunds extends BaseFormData {
  primarilyTrade: [] = null;
  geographicFocus: string = null;
  specificSector: string = null;
  trackRecord: string = null;
  annualizedReturn: string = null;
  annualizedVolatility: string = null;
  maximumDrawdown: string = null;
  sortinoRatio: string = null;
  strategydescription: string = null;
  aum: string = null;

  constructor() {
    super();
  }

  getFormGroup(): FormGroup {
    if (!this.formGroup) {
      this.formGroup = new FormGroup({
        strategydescription: new FormControl('', Validators.required),
        primarilyTrade: new FormArray([], Validators.required),
        geographicFocus: new FormControl(''),
        specificSector: new FormControl(''),
        trackRecord: new FormControl('', [Validators.required, Validators.pattern('^((?!trackRecord).)*$')]),
        annualizedReturn: new FormControl('', [Validators.required,Validators.pattern('^-?[0-9,\.]+$')]),
        annualizedVolatility: new FormControl('', [Validators.required, Validators.min(0),Validators.pattern('^-?[0-9,\.]+$')]),
        maximumDrawdown: new FormControl('', [Validators.required,Validators.pattern('^-?[0-9,\.]+$')]),
        sortinoRatio: new FormControl('', [Validators.required,Validators.pattern('^-?[0-9,\.]+$')]),
        aum: new FormControl('', [Validators.required,Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')])
      });
    }
    return this.formGroup;
  }

}

export class ClosedEndFunds extends BaseFormData {
  strategydescription: string = null;
  strategyDescription: [] = null;
  priorLaunched: string = null;
  irr: string = null;
  moic: string = null;
  investmentPeriod: string = null;
  harvestPeriod: string = null;
  targetFundraise: string = null;
  currentAmount: string = null;
  finalCloseDate: string = null;

  constructor() {
    super();
  }

  getFormGroup(): FormGroup {
    if (!this.formGroup) {
      this.formGroup = new FormGroup({
        strategydescription: new FormControl('', Validators.required),
        strategyDescription: new FormArray([], Validators.required),
        priorLaunched: new FormControl('', [Validators.required, Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')]),
        irr: new FormControl('', Validators.pattern('^-?[0-9,\.]+$')), // [Validators.min(0)]),
        moic: new FormControl('', Validators.pattern('^-?[0-9,\.]+$')), // [Validators.min(0)]),
        investmentPeriod: new FormControl('', Validators.required),
        harvestPeriod: new FormControl('', Validators.required),
        targetFundraise: new FormControl('', [Validators.required, Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')]),
        currentAmount: new FormControl('', [Validators.required, Validators.min(0), Validators.pattern('^-?[0-9,\.]+$')]),
        finalCloseDate: new FormControl('', Validators.required)
      });
    }
    return this.formGroup;

  }
}
export class OtherFunds extends BaseFormData {


  fundDescription: string = null;
  establishedTrackRecord: string = null;
  trackRecirdDescription: string = null;
  raisedOutsideCapital: string = null;
  currentlyCommited: string = null;
  commitmentDeadline: string = null;

  constructor() {
    super();
  }

  getFormGroup(): FormGroup {
    if (!this.formGroup) {
      this.formGroup = new FormGroup({
        fundDescription: new FormControl('', Validators.required),
        establishedTrackRecord: new FormControl('', Validators.required),
        trackRecirdDescription: new FormControl(),
        raisedOutsideCapital: new FormControl('', Validators.required),
        currentlyCommited: new FormControl('',[Validators.pattern('^-?[0-9,\.]+$'),Validators.min(0)]),
        commitmentDeadline: new FormControl('', Validators.required)
      });
    }
    return this.formGroup;

  }
}
